import React from 'react'

const loader = () => (
  <div className="loader">
    ...Loading
  </div>
)

export default loader
